module.exports = __webpack_public_path__ + "img/ss_ye-02.1f678bb3.jpg";